import { render, staticRenderFns } from "./TargetPrize.vue?vue&type=template&id=58284c08&scoped=true&"
import script from "./TargetPrize.vue?vue&type=script&lang=js&"
export * from "./TargetPrize.vue?vue&type=script&lang=js&"
import style0 from "./TargetPrize.vue?vue&type=style&index=0&id=58284c08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58284c08",
  null
  
)

export default component.exports